import { render, staticRenderFns } from "./DescargarBoletines.vue?vue&type=template&id=51972df0&"
import script from "./DescargarBoletines.vue?vue&type=script&lang=js&"
export * from "./DescargarBoletines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports